import { withRouter, Link } from "react-router-dom";

import PropTypes from 'prop-types';
import Slider from 'react-slick';

import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import NumberFormat from 'react-number-format';

import {
  Grid,
  Avatar,
  Typography,
  LinearProgress,
  Paper,
  Box
} from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';

import useResponsive from '../../utils/useResponsive';

import Products from "../../components/Products";
import { useSelector, useDispatch } from 'react-redux';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';

import { FiSearch } from 'react-icons/fi';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const ITEM_HEIGHT = 68;
const ITEM_PADDING_TOP = 8;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function OrderPage({ props }) {

  const [open, setOpen] = React.useState(false);

  const [grade, setGrade] = useState([]);
  const [griffe, setGriffe] = useState([]);
  const [filial, setFilial] = useState([]);
  const [grupo, setGrupo] = useState([]);
  const [subgrupo, setSubgrupo] = useState([]);

  const [dataUser, setDataUser] = useState('');
  const loading = useSelector(state => state.loading);
  const search = useSelector(state => state.search);

  const isDesktop = useResponsive('up', 'md');

  const carouselRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        settings: {
          slidesToShow: 3
        }
      },
      {
        settings: {
          slidesToShow: 2
        }
      },
      {
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  function BookingItem({ item }) {
    const { avatar, name, roomNumber, bookdAt, person, cover, roomType } = item;

    return (
      <Paper sx={{
        borderRadius: 2.5,
        border: '1px solid',
        borderColor: 'grey.200',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        bgcolor: '#fff'
      }}>
        <Box sx={{ p: 1, position: 'relative' }}>
          <Box component="img" src={cover} sx={{ borderRadius: 1.5, width: 100 }} />
        </Box>
      </Paper>
    );
  }

  const handleGriffe = (griffe) => {
    if (griffe !== null) {
      setGriffe(griffe.map((item) => item.value));
    }
  };

  const handleFilial = (filial) => {
    setFilial(filial ? filial.map((item) => item.value) : []);
  };

  const handleGrupo = (grupo) => {
    if (grupo !== null) {
      setGrupo(grupo.map((item) => item.value))
    }
  };

  const handleSubgrupo = (subgrupo) => {
    if (subgrupo !== null) {
      setSubgrupo(subgrupo.map((item) => item.value));
    }
  };

  const handleGrade = (grade) => {
    if (grade !== null) {
      setGrade(grade.map((item) => item.value));
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Dialog */}
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <Box sx={{ bgcolor: '#f5f5f5', height: '100vh' }}>
          <AppBar sx={{ bgcolor: '#1a1a2e' }}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
        </Box>
      </Dialog>

      {loading === true ? (
        <LinearProgress />
      ) : (
        <>
          {/* Search Results Header */}
          {search.length > 0 && (
            <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', maxWidth: '98%', mx: 'auto' }}>
              <Box sx={{ py: 3, px: { xs: 2, md: 3 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                    <FiSearch size={18} />
                  </Avatar>
                  <Typography variant={isDesktop ? "h5" : "body2"} sx={{ fontWeight: 700 }}>
                    Resultados encontrados para <Box component="span" sx={{ fontWeight: 800 }}>"{search}"</Box>
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

          {/* Content */}
          <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
            <Grid container>
              <Grid item md={12} xs={12}>
                <Products style={{ marginTop: 50 }} />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </Box>
  )
}
export default withRouter(OrderPage)
